export default __webpack_public_path__ + "images/0c18b50368de7143c13da2ab4fca320e.png";